import { CommonModule } from '@angular/common';
import { Component, ElementRef, HostListener, Input, OnInit, Optional, Self } from '@angular/core';
import { ControlValueAccessor, FormsModule, NgControl, ReactiveFormsModule } from '@angular/forms';

@Component({
  selector: 'app-searchable-dropdown',
  imports: [CommonModule, FormsModule, ReactiveFormsModule],
  templateUrl: './searchable-dropdown.html',
  styleUrl: './searchable-dropdown.scss',
  standalone: true,
})
export class SearchableDropdown implements ControlValueAccessor, OnInit {
  @Input() label = '';
  @Input() items: any[] = [];
  @Input() bindLabel = '';
  @Input() bindValue = '';
  @Input() placeholder = 'Select';
  @Input() errorMessage = 'This field is required';

  showDropdown = false;
  searchText = '';
  selectedLabel = '';

  filteredItems: any[] = [];

  onChange: any = () => {};
  onTouched: any = () => {};

  constructor(
    @Optional() @Self() public ngControl: NgControl,
    private elementRef: ElementRef,
  ) {
    if (this.ngControl) {
      this.ngControl.valueAccessor = this;
    }
  }

  get invalid(): boolean {
  return !!(
    this.ngControl &&
    this.ngControl.invalid &&
    (this.ngControl.touched || this.ngControl.dirty)
  );
}


  get control() {
    return this.ngControl?.control;
  }

  get showSearch(): boolean {
    return this.items.length > 5;
  }

  ngOnInit() {
    this.filteredItems = this.items;
  }

  toggleDropdown() {
    this.showDropdown = !this.showDropdown;
    this.filteredItems = this.items;
  }

  selectItem(item: any) {
    this.selectedLabel = item[this.bindLabel];
    this.onChange(item[this.bindValue]);
    this.showDropdown = false;
  }

  writeValue(value: any): void {
    if (value === null || value === undefined || value === '') {
      this.selectedLabel = '';
      this.searchText = '';
      this.showDropdown = false;
      return;
    }

    if (this.items.length) {
      const selected = this.items.find((i) => i[this.bindValue] === value);
      this.selectedLabel = selected ? selected[this.bindLabel] : '';
    }
  }

  registerOnChange(fn: any): void {
    this.onChange = fn;
  }

  registerOnTouched(fn: any): void {
    this.onTouched = fn;
  }

  get filteredItemsList() {
    return this.items.filter((item) =>
      item[this.bindLabel]?.toLowerCase().includes(this.searchText.toLowerCase()),
    );
  }

  closeDropdown() {
    this.showDropdown = false;
  }
  @HostListener('document:click', ['$event'])
  onDocumentClick(event: MouseEvent) {
    const clickedInside = this.elementRef.nativeElement.contains(event.target);
    if (!clickedInside) {
      this.closeDropdown();
    }
  }
}
